import {ROUTES} from '../../../app.routes';
import {MenuItem} from './menu-item';

const SECURE = ROUTES.SECURE;

export const GETPAID_MENU: MenuItem[] = [
    {
        kind: 'group',
        label: 'Account Details',
        icon: 'fas fa-address-card',
        collapseKey: 'account',
        children: [
            {kind: 'link', label: 'Account Settings', icon: 'fas fa-cogs', route: SECURE.BUSINESS.EDIT},
            {kind: 'link', label: 'Users', icon: 'fas fa-user-edit', route: SECURE.USER.LIST, exact: true},
            {kind: 'link', label: 'User Invitations', icon: 'fas fa-user-plus', route: SECURE.USER.INVITATION.LIST},
            {kind: 'link', label: 'Invoices', icon: 'fas fa-file-alt', route: SECURE.INVOICES.LIST}
        ]
    },
    {
        kind: 'group',
        label: 'Request to Pay',
        icon: 'fas fa-file-invoice-dollar',
        collapseKey: 'payment',
        children: [
            {
                kind: 'link',
                label: 'Quick Pay',
                icon: 'fas fa-bolt',
                route: SECURE.ACCOUNT.QUICK_PAY_CREATE,
                exact: true,
                extraPrivileges: [SECURE.ACCOUNT.READONLY_CREATE.privilege]
            },
            {
                kind: 'link',
                label: 'Create Invoice',
                icon: 'fas fa-money-check-alt',
                route: SECURE.ACCOUNT.CREATE,
                exact: true,
                extraPrivileges: [SECURE.ACCOUNT.READONLY_CREATE.privilege]
            },
            {
                kind: 'link',
                label: 'Upload Bulk File',
                icon: 'fas fa-file-import',
                route: SECURE.ACCOUNT.UPLOAD_REQUESTS_FILE,
                exact: true,
                extraPrivileges: [SECURE.ACCOUNT.READONLY_UPLOAD_REQUESTS_FILE.privilege],
                hidden: (ctx) => !ctx.isBulkEnabled
            }
        ]
    },
    {
        kind: 'link',
        label: 'QR Codes',
        icon: 'fas fa-solid fa-qrcode',
        route: SECURE.QR.LIST,
        exact: true,
        hidden: (ctx) => !ctx.isQrCodesEnabled
    },
    {
        kind: 'group',
        label: 'Dashboards',
        icon: 'fa fa-dashboard',
        collapseKey: 'dashboard',
        children: [
            {
                kind: 'link',
                label: 'Individual',
                icon: 'fas fa-receipt',
                route: SECURE.ACCOUNT.LIST,
                exact: true
            },
            {
                kind: 'link',
                label: 'E-Commerce',
                icon: 'fas fa-shopping-cart',
                route: SECURE.ACCOUNT.ECOMMERCE,
                exact: true,
                hidden: (ctx) => !ctx.env.eCommerceEnabled || !ctx.isEcommerceMerchant
            },
            {
                kind: 'link',
                label: 'Bulk',
                icon: 'pi pi-list',
                route: SECURE.ACCOUNT.BULK,
                exact: true
            },
            {
                kind: 'link',
                label: 'QR Payments',
                icon: 'pi pi-qrcode',
                route: SECURE.QR.PAYMENTS,
                exact: true
            }
        ]
    },
    {kind: 'link', label: 'Settlement', icon: 'fas fa-receipt', route: SECURE.SETTLEMENT_BATCH.LIST},
    {
        kind: 'link',
        label: 'Purchase',
        icon: 'fa fa-shopping-bag',
        route: SECURE.PURCHASE.MESSAGE_BUNDLES,
        badgeIndicator: 'signupFeeUnpaid'
    },
    {kind: 'external', label: 'Get Help', icon: 'fas side-menu-fa-question-circle fa-question-circle', onClick: 'help'},
    {
        kind: 'group',
        label: 'Ts and Cs',
        icon: 'fas fa-file-pdf',
        collapseKey: 'tsAndCs',
        children: [
            {kind: 'external', label: 'Service Terms', href: 'env:serviceTermsLink', target: '_blank'},
            {kind: 'external', label: 'General Terms', href: 'env:generalTermsLink', target: '_blank'},
            {kind: 'external', label: 'Privacy Notice', href: 'env:privacyNoticeLink', target: '_blank'}
        ]
    },
    {kind: 'link', label: 'FAQ', icon: 'fas fa-info-circle', route: ROUTES.PUBLIC.FAQS, target: '_blank'},
    {kind: 'external', label: 'Sign Out', icon: 'fas fa-sign-out', onClick: 'logout'}
];
